import { render, staticRenderFns } from "./ChipDate.vue?vue&type=template&id=58341e8e&scoped=true"
import script from "./ChipDate.vue?vue&type=script&lang=js"
export * from "./ChipDate.vue?vue&type=script&lang=js"
import style0 from "./ChipDate.vue?vue&type=style&index=0&id=58341e8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58341e8e",
  null
  
)

export default component.exports